<template>
  <v-app>
      <Root/>
  </v-app>
</template>

<script>
import Root from './components/Root';

export default {
  name: 'App',

  components: {
    Root,
  },

  data: () => ({
    //
  }),
};
</script>
